module.exports = __webpack_public_path__ + "static/media/megaphone.d1741483.svg";